<div class="flex-row dialog-container">
  <div class="flex-row">
    <img class="gif" src="assets/images/loading.gif" width="100px" />
  </div>
  <div class="flex-col">
    <div class="flex-row title">Please, wait</div>
    <div class="flex-row message">We are retrieving your data...</div>
  </div>
</div>
